import React from "react";

import { Form, InputNumber } from "antd";
import { addCommasToNumber, cleanNumberFromCommas } from "../../../../ManagePatientDetails/financialUtils";

export const CurrencyItem = ({ name, label, placeholder, required, rules = [], fieldProps = {} }) => {
  return (
    <Form.Item rules={[{ required }, ...rules]} name={name} label={label}>
      <InputNumber
        formatter={(value) => addCommasToNumber(value)}
        parser={(value) => cleanNumberFromCommas(value)}
        min={0}
        {...fieldProps}
        placeholder={placeholder}
      />
    </Form.Item>
  );
};
